import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import styles from './InfoTooltip.module.scss'

const InfoTooltip = ({
  content,
  placement = 'top',
  size = 'small',
  iconColor
}) => {
  const tooltipContent = typeof content === 'string'
    ? <Typography className={styles.tooltipText}>{content}</Typography>
    : content

  return (
    <Tooltip
      title={tooltipContent}
      placement={placement}
      arrow
    >
      <InfoIcon
        className={`${styles.icon} ${styles[size]}`}
        style={iconColor ? { color: iconColor } : undefined}
        fontSize={size === 'small' ? 'small' : 'medium'}
        aria-label='More information'
      />
    </Tooltip>
  )
}

InfoTooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  placement: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  iconColor: PropTypes.string
}

export default InfoTooltip
